module.exports = "<cat-panel title=\"Feature Parameters\">\n\n  <cat-panel-linked-list\n    [items]=\"linkedParametersList\"></cat-panel-linked-list>\n</cat-panel>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/feature-parameter/components/feature-parameter-landing/feature-parameter-landing.component.html
// module id = ../../../../../src/app/modules/models/feature-parameter/components/feature-parameter-landing/feature-parameter-landing.component.html
// module chunks = main